import React from 'react';

/**
 * Toggle switch component with labels
 * @param {Object} props - Component props
 * @param {boolean} props.isOn - Whether the toggle is on
 * @param {Function} props.handleToggle - Function to call when toggle is clicked
 * @param {string} props.labelLeft - Label for the left (off) state
 * @param {string} props.labelRight - Label for the right (on) state
 * @returns {JSX.Element} Toggle switch component
 */
const ToggleSwitch = ({ isOn, handleToggle, labelLeft, labelRight }) => {
  // Radioactive green color for semantic search
  const radioactiveGreen = '#39FF14';
  
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
      <span style={{ 
        color: !isOn ? '#007bff' : '#aaa',
        fontWeight: !isOn ? 'bold' : 'normal',
        fontSize: '14px'
      }}>
        {labelLeft}
      </span>
      
      <div 
        onClick={handleToggle}
        style={{
          position: 'relative',
          width: '40px',
          height: '20px',
          backgroundColor: isOn ? radioactiveGreen : '#444',
          borderRadius: '10px',
          cursor: 'pointer',
          transition: 'background-color 0.3s',
          boxShadow: isOn ? `0 0 8px ${radioactiveGreen}` : 'none', // Glow effect when on
        }}
      >
        <div style={{
          position: 'absolute',
          left: isOn ? '20px' : '0px',
          top: '2px',
          width: '16px',
          height: '16px',
          backgroundColor: 'white',
          borderRadius: '50%',
          transition: 'left 0.3s'
        }} />
      </div>
      
      <span style={{ 
        color: isOn ? radioactiveGreen : '#aaa',
        fontWeight: isOn ? 'bold' : 'normal',
        fontSize: '14px',
        textShadow: isOn ? `0 0 5px ${radioactiveGreen}` : 'none', // Text glow effect when on
      }}>
        {labelRight} {isOn && '⚡'} {/* Add lightning bolt emoji when on */}
      </span>
    </div>
  );
};

export default ToggleSwitch;